import React from "react";
import { useLocation } from "react-router-dom";

/*
 * Osłona całej aplikacji: bez niej jeden nieobsłużony błąd w renderowaniu
 * (np. nieoczekiwany kształt treści z panelu) odmontowuje cały React i klient
 * widzi pustą stronę. Z nią — krótki komunikat z przyciskiem "Odśwież".
 * Komunikat nie zależy od CMS ani API (to one mogły być przyczyną błędu).
 * Przy zmianie adresu osłona sama się zeruje (key z useLocation), więc błąd na
 * jednej podstronie nie blokuje reszty serwisu.
 */
class Boundary extends React.Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info?.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main role="alert" style={{ maxWidth: 520, margin: "0 auto", padding: "96px 24px", textAlign: "center" }}>
        <h1 style={{ fontSize: 26, margin: "0 0 12px" }}>Nie udało się wyświetlić tej strony</h1>
        <p style={{ margin: "0 0 24px", lineHeight: 1.6 }}>
          Spróbuj odświeżyć stronę. Jeśli problem się powtarza, wróć na stronę główną albo napisz do nas — dane Twoich
          zamówień są bezpieczne.
        </p>
        <button type="button" className="btn wax" onClick={() => window.location.reload()}>
          Odśwież stronę
        </button>{" "}
        <a className="btn" href="/">
          Strona główna
        </a>
      </main>
    );
  }
}

export default function ErrorBoundary({ children }) {
  const { pathname } = useLocation();
  return <Boundary key={pathname}>{children}</Boundary>;
}
